import React from "react";
import { useSelector } from "react-redux";

import Checkbox from "@cayuse/shared-react.components.form.inputs.checkbox";
import { crunchClasses } from "@cayuse/shared-react.utils.helpers";

import { EditableTableCell } from "components/BudgetBuilder/shared/EditableTableCell";
import ExpandIcon from "components/BudgetBuilder/shared/ExpandIcon";
import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import OrgSearchInput from "components/OrgSearchInput";
import Table from "components/Table";
import { budgetBuilderSelectors } from "store/selectors";
import { formatNumberAsPercent, getFACost, getPeriodTotalCost } from "utils/budgetBuilder";

import styles from "./styles.css";


const LineItemsRow = (
	{
		category,
		childPosition,
		isEditing,
		updateLineItem,
		handleIsExpandedChange,
	}
) => {
	const isSubawardChild = false;
	const { currencyFormatter } = useTenantFormatter();
	let { hash, value, isFA, directCost, isExpanded } = category;
	const currentPeriodRate = useSelector(budgetBuilderSelectors.currentPeriodRate);
	const isParent = childPosition === undefined;
	const classNames = crunchClasses({
		[styles.row]: true,
		[styles.parentRow]: childPosition === undefined,
		[styles.hiddenRow]: !isParent && !isExpanded,
	});


	const onOrgFinderChange = payload => updateLineItem(hash, { value: payload });

	return (
		<Table.Row
			key={hash}
			id={hash}
			className={classNames}
		>
			<Table.Cell className={styles.expandCell}>
				{!isEditing || (!isSubawardChild || isParent)
					? <span>{value}</span>
					: (
						// TODO - remove this + test, this functionality is replaced by SubawardLineItemRow
						<OrgSearchInput
							onChange={onOrgFinderChange}
							value={value}
							className={styles.orgFinderDropdown}
						/>
					)
				}
				{isParent && (
					<ExpandIcon
						isExpanded={isExpanded}
						onClick={() => handleIsExpandedChange(category)}
					/>
				)}
			</Table.Cell>
			<EditableTableCell
				hideContent={isParent}
				editable={isEditing}
				cellStyles={`${styles.cellAlignRight} ${styles.valueCellPadding}`}
				textFormatter={currencyFormatter}
				value={directCost}
				onChange={event => updateLineItem(hash, { directCost: event.target.value })}
			/>
			<Table.Cell className={styles.cellAlignRight}>
				<Checkbox
					checked={isFA}
					disabled={!isEditing}
					onClick={() => updateLineItem(category.hash, { isFA: !isFA })}
				/>
			</Table.Cell>
			<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`}>
				{!isParent && <span className={styles.cellAlignRight}>
					{formatNumberAsPercent(currentPeriodRate, "0%")}
				</span>}
			</Table.Cell>
			<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`}>
				{!isParent && <span className={`${styles.cellAlignRight} ${styles.bold}`}>
					{currencyFormatter(getFACost(category, currentPeriodRate))}
				</span>}
			</Table.Cell>
			<Table.Cell className={`${styles.cellAlignRight} ${styles.valueCellPadding}`}>
				{!isParent && <span className={`${styles.cellAlignRight} ${styles.bold}`}>
					{currencyFormatter(getPeriodTotalCost(category, currentPeriodRate))}
				</span>}
			</Table.Cell>
			<Table.Cell className={styles.cellAlignCenter}/>
		</Table.Row>
	);
};

export default LineItemsRow;
